import type { ButtonHTMLAttributes, ReactNode } from 'react';

type Variant = 'primary' | 'ghost' | 'outline';

const VARIANTS: Record<Variant, string> = {
  primary:
    'bg-accent text-white hover:bg-accent-hover focus-visible:ring-2 focus-visible:ring-accent/50',
  ghost: 'bg-transparent text-[#8b8d9a] hover:bg-white/[0.06] hover:text-[#ededf0]',
  outline: 'border border-white/[0.12] bg-transparent text-[#ededf0] hover:bg-white/[0.05]',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  children: ReactNode;
}

export function Button({ variant = 'primary', className = '', children, ...props }: ButtonProps) {
  return (
    <button
      className={`
        inline-flex items-center justify-center gap-2 rounded-md px-4 py-2
        text-sm font-medium transition-colors duration-150
        disabled:pointer-events-none disabled:opacity-40
        ${VARIANTS[variant]} ${className}
      `}
      {...props}
    >
      {children}
    </button>
  );
}
